import httpApiApplication from 'app/http/httpApiApplication';

import { type Tax } from '../models/Tax';
import { type TaxPeriodicity } from '../models/Tax';
import { type TaxRate } from '../models/Tax';

export const BaseUrlTax = '/taxes';
export const BaseUrlTaxRates = '/TaxRates';
export const BaseUrlTaxPeriodicity = '/TaxPeriodicity';
export const BaseUrlTaxpayer = '/taxpayers';

export const taxService = {
  updateTax: async (id: string, tax: Tax): Promise<void> => {
    return httpApiApplication.put<void>(`${BaseUrlTax}/${id}`, tax);
  },
  deleteTax: async (id: string): Promise<void> => {
    return httpApiApplication.delete(`${BaseUrlTax}/${id}`);
  },
  updateTaxRate: async (taxId: string, id: string, taxRate: TaxRate) => {
    return httpApiApplication.put(`${BaseUrlTax}/${taxId}${BaseUrlTaxRates}/${id}`, taxRate);
  },
  deleteTaxRate: (taxId: string, id: string) => {
    return httpApiApplication.delete(`${BaseUrlTax}/${taxId}${BaseUrlTaxRates}/${id}`);
  },
  updateTaxPeriodicity: async (taxId: string, id: string, taxPeriodicity: TaxPeriodicity) => {
    return httpApiApplication.put(
      `${BaseUrlTax}/${taxId}${BaseUrlTaxPeriodicity}/${id}`,
      taxPeriodicity
    );
  },
  deleteTaxPeriodicity: async (taxId: string, id: string) => {
    return httpApiApplication.delete(`${BaseUrlTax}/${taxId}${BaseUrlTaxPeriodicity}/${id}`);
  },
  createTax: async (tax: Tax) => {
    return httpApiApplication.post(BaseUrlTax, tax);
  },

  createTaxRate: async (taxId: string, taxRate: TaxRate) => {
    return httpApiApplication.post(`${BaseUrlTax}/${taxId}${BaseUrlTaxRates}`, taxRate);
  },

  createTaxPeriodicity: async (taxId: string, taxPeriodicity: TaxPeriodicity) => {
    return httpApiApplication.post(
      `${BaseUrlTax}/${taxId}${BaseUrlTaxPeriodicity}`,
      taxPeriodicity
    );
  }
};
